import React from "react";
import "./analyticsNavbar.css";
import { ListOfAnalytics } from "../../utils/constants.";

const AnalyticsNavbar = ({ activeAnalytics, handleAnalyticsClick }) => {
  return (
    <div className="analytics-navbar">
      {ListOfAnalytics.map((analytics) => {
        return (
          <a
            key={analytics.id}
            className={`navbar-item ${activeAnalytics === analytics.id ? "selected" : ""} `}
            onClick={() => {
              handleAnalyticsClick(analytics);
            }}
            name={analytics.id}
          >
            <div>{analytics.name}</div>
          </a>
        );
      })}
    </div>
  );
};

export default AnalyticsNavbar;
